const KEY = 'bitutravel.postLoginRedirect'

/**
 * The login guard passes `state.from` so a user who was bounced to login can be
 * sent back where they were headed. Magic-link auth survives a full page
 * navigation (the email click), so the intended path can't travel in router
 * state — it round-trips through sessionStorage instead.
 */
export function savePostLoginRedirect(path: string | null | undefined) {
  if (!path || !path.startsWith('/')) return
  try {
    sessionStorage.setItem(KEY, path)
  } catch {
    // Private mode / disabled storage — the user just lands on the default page.
  }
}

export function takePostLoginRedirect(): string | null {
  try {
    const value = sessionStorage.getItem(KEY)
    if (value) sessionStorage.removeItem(KEY)
    return value
  } catch {
    return null
  }
}